import { useState } from 'react'
import './Add.css'

const Add = () => {
  const api = "http://localhost:8000/house"
  const [state, setstate] = useState('')
  const [area, setarea] = useState('')
  const [rooms, setrooms] = useState(null)
  const [price, setprice] = useState(null)
  const [city, setcity] = useState('')
  const [is_available, setis_available] = useState(true)
  const [veiws, setveiws] = useState(0)
  const [description, setdescription] = useState('')
  const [file, setfile] = useState(null)

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {

      const fileReader = new FileReader();

      fileReader.readAsDataURL(file);

      fileReader.onload = () => {

        resolve(fileReader.result);

      };

      fileReader.onerror = (error) => {

        reject(error);

      };

    });
  }

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const base64 = await convertToBase64(file);
    console.log(base64)
    setfile(base64)
  };



  let handleSave = () => {
    const homeData = { state, area,price, city, is_available, veiws, description, file }
    console.log(homeData)
    const res = fetch(api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(homeData)
    })


  }

  return (
    <div className="add container">
      <form>
        <label htmlFor="state">Enter your state:</label>
        <input type="text" id="state" name="state" value={state} onChange={e => { setstate(e.target.value) }} />
        <br />

        <label htmlFor="area">Enter your area:</label>
        <input type="number" id="area" name="area" value={area} onChange={e => { setarea(e.target.value) }} />
        <br />

        <label htmlFor="rooms">Enter your rooms:</label>
        <input type="number" id="rooms" name="rooms" value={rooms} onChange={e => { setrooms(e.target.value) }} />
        <br />

        <label htmlFor="price">Enter your price:</label>
        <input type="text" id="price" name="price" value={price} onChange={e => { setprice(e.target.value) }} />
        <br />

        <label htmlFor="city">Enter your city:</label>
        <input type="text" id="city" name="city" value={city} onChange={e => { setcity(e.target.value) }} />
        <br />

        <label htmlFor="description">Enter your description:</label>
        <input type="textarea" id="description" name="description" value={description} onChange={e => { setdescription(e.target.value) }} />
        <br />

        <label htmlFor="img">Enter your img:</label>
        <input type="file" id="img" name="img" onChange={handleFileUpload} />
        <br />
      </form>
      <button onClick={handleSave}>save</button>

    </div>
  )
}

export default Add